import * as React from "react";
const SvgAward01 = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M18 9A6 6 0 1 0 6 9a6 6 0 0 0 12 0m-2.764 7.315A8 8 0 0 1 12 17a8 8 0 0 1-3.236-.685l-.5 3.76 2.81-1.685c.09-.054.327-.21.605-.272l.16-.026q.161-.018.322 0l.16.026.103.027c.232.071.423.198.502.245l2.81 1.685zM20 9a7.98 7.98 0 0 1-2.9 6.161l.891 6.707a1 1 0 0 1-1.506.99L12 20.165l-4.485 2.691a1 1 0 0 1-1.506-.989l.89-6.706A8 8 0 1 1 20 9"
}));
export default SvgAward01;
//# sourceMappingURL=Award01.js.map